<template>
  <section>
    <gs-header title="Danh sách đơn đối soát" :breadcrumbs="[
      { title: 'Quản lý đối soát', route: { name: 'compare' } }
    ]">
      <el-button type="primary" size="small" @click="exportExcel" icon="el-icon-download">Xuất excel</el-button>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="compareTable" :table-name="compareTable" data-source="compares" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters" style="margin-bottom: 24px;">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="block">
                <el-date-picker size="small" class="width-100" v-model="filterDateRange" type="daterange" range-separator=" / "
                  @input="updateFilters" format="dd-MM-yyyy" start-placeholder="Từ ngày" end-placeholder="Đến ngày">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="18">
              <el-radio-group class="status-listting" v-model="filters.status" v-if="compareHelpers.statuses"
                :fill="listtingComparesStatusBg[filters.status]" @change="filter">
                <el-radio-button :label="index" v-for="(status, index) in compareHelpers.statuses" :key="index">
                  <el-tooltip placement="top" content="Trạng thái" class="display-inline">
                    <span :class="{ [listtingComparesStatus[index]]: filters.status != index }">{{ status }}</span>
                  </el-tooltip>
                </el-radio-button>
                <el-radio-button :label="-1">
                  <el-tooltip placement="top" content="Trạng thái" class="display-inline">
                    <span :class="{ [listtingComparesStatus[-1]]: filters.status != -1 }">Tất cả</span>
                  </el-tooltip>
                </el-radio-button>
              </el-radio-group>
            </el-col>
            <el-col :span="24">
              <el-radio-group class="status-listting" v-model="filters.error_id" v-if="compareHelpers.errors"
                :fill="listtingComparesErrorBg[filters.error_id]" @change="filter">
                <el-radio-button :label="index" v-for="(error, index) in compareHelpers.errors" :key="index">
                  <el-tooltip placement="top" content="Vận đơn lỗi" class="display-inline">
                    <span :class="{ [listtingComparesError[index]]: filters.error_id != index }">{{ error }}</span>
                  </el-tooltip>
                </el-radio-button>
                <el-radio-button :label="-1">
                  <el-tooltip placement="top" content="Vận đơn lỗi" class="display-inline">
                    <span :class="{ [listtingComparesError[-1]]: filters.error_id != -1 }">Tất cả</span>
                  </el-tooltip>
                </el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
          <!-- <el-divider></el-divider> -->
        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" border style="width: 100%">
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[compareTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[compareTable].current_page - 1) * dataPaginations[compareTable].per_page) }}</small>
              </template>
            </el-table-column>

            <el-table-column label="Đối Soát" width="200">
              <template slot-scope="scope">
                <p v-if="scope.row.shipment" :class="shipmentStatuses[scope.row.shipment.data.status]">
                  <el-tooltip placement="top" content="Trạng thái vận đơn" class="display-inline">
                    <span><i aria-hidden="true" class="fa fa-file-text-o"></i> {{ scope.row.shipment.data.status_txt }}
                      <small v-if="scope.row.shipment.data.is_return">(Chuyển hoàn)</small><small
                        v-if="scope.row.shipment.data.is_part_delivery">(Giao một phần)</small><small
                        v-if="scope.row.shipment.data.is_lost">(Thất lạc)</small></span>
                  </el-tooltip>
                </p>
                <p :class="listtingComparesStatus[scope.row.status]">
                  <el-tooltip placement="top" content="Trạng thái" class="display-inline">
                    <span><i aria-hidden="true" class="fa fa-info-circle"></i> {{ scope.row.status_txt }}</span>
                  </el-tooltip>
                </p>
                <p class="text-red">
                  <el-tooltip placement="top" content="Trạng thái lỗi" class="display-inline">
                    <span><i aria-hidden="true" class="fa fa-exclamation-circle"></i> {{ scope.row.error_txt }}</span>
                  </el-tooltip>
                </p>
                <p>
                  <el-tooltip placement="top" content="Ngày tạo" class="display-inline">
                    <span><i aria-hidden="true" class="fa fa-clock-o"></i> {{ scope.row.created_at }}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>

            <el-table-column label="">
              <template slot-scope="scope">
                <p v-if="scope.row.shipment"><span>Mã vận đơn: </span><span class="shipment-code-display click-copy"
                    v-if="scope.row.shipment">{{ scope.row.shipment.data.id }}</span></p>
                <p v-if="scope.row.shipment"><span>Mã đơn HVC: </span> <span class="shipment-code-display click-copy">{{
                  scope.row.shipment.data.code
                }}</span></p>
                <!-- <p v-if="scope.row.shipment"><span>Trạng thái vận đơn: </span> <span :class="shipmentStatuses[scope.row.shipment.data.status]">{{scope.row.shipment.data.status_txt}} <small v-if="scope.row.shipment.data.is_return">(Chuyển hoàn)</small><small v-if="scope.row.shipment.data.is_part_delivery">(Giao một phần)</small><small v-if="scope.row.shipment.data.is_lost">(Thất lạc)</small></span></p> -->
                <p v-if="scope.row.cross_check"><span>Mã lịch sử đối soát: </span> <span
                    class="shipment-code-display click-copy">{{ scope.row.cross_check.data.id }}</span></p>
                <p v-if="scope.row.shipment"><span>Mã phiếu chi cod: </span> <span class="shipment-code-display click-copy">{{
                  scope.row.shipment.data.invoice.data.id }}</span></p>
                <p v-if="scope.row.shipment"><span>Mã phiếu chi phí: </span> <span class="shipment-code-display click-copy">{{
                  scope.row.shipment.data.invoice_fee.data.id }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Thông Tin Khách Hàng">
              <template slot-scope="scope">
                <p v-if="scope.row.shipment && scope.row.client"><i class="fa fa-user"></i>&nbsp;{{
                  scope.row.client.data.name
                }}</p>
                <p v-if="scope.row.shipment && scope.row.client"><i class="fa fa-mobile"></i>&nbsp;<span
                    class="click-copy">{{ scope.row.client.data.phone }}</span></p>
                <p v-if="scope.row.shipment && scope.row.client"><i class="fa fa-envelope-o"
                    aria-hidden="true"></i>&nbsp;<span class="click-copy">{{ scope.row.client.data.email }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="">
              <template slot-scope="scope">
                <p>Tiền thu hộ (COD)</p>
                <p>Tổng phí</p>
                <p>Khuyến mãi</p>
                <p>Cân nặng</p>
                <p>Cân quy đổi</p>
                <p>Tạm thu</p>
              </template>
            </el-table-column>

            <el-table-column label="Thông Tin Đối Soát">
              <template slot-scope="scope">
                <div class="text-red">
                  <p class="text-right click-copy">{{ scope.row.cod_amount | vnd }}</p>
                  <p class="text-right click-copy">{{ scope.row.total_fee | vnd }}</p>
                  <p class="text-right click-copy">0 đ</p>
                </div>
                <p class="text-right click-copy">{{ scope.row.weight | gam }}</p>
                <p class="text-right click-copy">{{ scope.row.convertion_weight | gam }}</p>
                <p class="text-right click-copy text-red">{{ scope.row.payed_fee | gam }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Thông Tin Vận Đơn">
              <template slot-scope="scope">
                <div class="text-red">
                  <p v-if="scope.row.shipment" class="click-copy">{{ scope.row.shipment.data.amount_for_cross | vnd }}
                  </p>
                  <p v-if="scope.row.shipment" class="click-copy">{{ scope.row.shipment.data.total_fee | vnd }}</p>
                  <p v-if="scope.row.shipment" class="click-copy">{{ scope.row.shipment.data.discount | vnd }}</p>
                </div>
                <p v-if="scope.row.parcel" class="click-copy">{{ scope.row.parcel.data.weight | gam }}</p>
                <p v-if="scope.row.parcel" class="click-copy">{{ scope.row.parcel.data.convertion_weight | vnd }}</p>
                <p class="text-right click-copy">&nbsp;</p>
              </template>
            </el-table-column>

            <el-table-column label="Thông tin tài chính">
              <template slot-scope="scope">
                <div class="text-red">
                  <!-- <p v-if="scope.row.shipment">COD: <span class="pull-right click-copy">{{scope.row.cod_amount | svnd}}</span></p> -->
                  <p v-if="scope.row.shipment">Revenue: <span class="pull-right click-copy">{{
                    scope.row.shipment.data.total_fee | vnd
                  }}</span></p>
                  <p v-if="scope.row.shipment">Cost: <span class="pull-right click-copy">{{
                    scope.row.total_fee |
                    vnd
                  }}</span></p>
                  <p v-if="scope.row.shipment">Profit: <span class="pull-right click-copy">{{
                    scope.row.shipment.data.total_fee - scope.row.total_fee |
                    vnd
                  }}</span></p>
                </div>
              </template>
            </el-table-column>

            <!--  <el-table-column
              width="95"
            >
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">

                </section>
              </template>
            </el-table-column> -->
          </el-table>
        </template>
      </gs-table>
    </div>
  </section>
</template>

<script lang="js">
import { mapActions, mapGetters } from 'vuex'
import { debounce, keys, forEach } from 'lodash'
import ls from 'local-storage'
import { exportExcel } from 'src/api/compares'
import { listtingComparesStatus, listtingComparesStatusBg, listtingComparesError, listtingComparesErrorBg } from 'src/stubs/compares'
import { shipmentStatuses } from 'src/stubs/shipments'
import { formatDate } from 'src/helpers'
export default {
  name: 'ListtingAllCompare',
  data() {
    return {
      compareTable: 'compares',
      filters: {
        sort: 'created_at:-1',
        include: 'client,carrier,parcel,cross_check,shipment.invoice,shipment.invoice_fee',
        error_id: -1,
        status: -1,
        start_date: '',
        end_date: ''
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ],
      listtingComparesStatus: listtingComparesStatus,
      listtingComparesStatusBg: listtingComparesStatusBg,
      listtingComparesError: listtingComparesError,
      listtingComparesErrorBg: listtingComparesErrorBg,
      shipmentStatuses: shipmentStatuses,
      filterDateRange: ''
    }
  },
  computed: {
    ...mapGetters('compare', ['compareHelpers'])
  },
  watch: {
    '$route.query': {
      handler(newQuery) {
        this.filters = { ...this.filters, ...newQuery }
        if (this.filters.start_date && this.filters.end_date) {
          this.filterDateRange = [
            this.filters.start_date,
            this.filters.end_date,
          ]
        }
        ['error_id', 'status'].forEach((key) => {
          if (this.filters[key]) {
            this.filters[key] = Number(this.filters[key])
          }
        })
      },
      deep: true, // Theo dõi sâu các thay đổi bên trong đối tượng query (nếu cần)
      immediate: true, // Gọi handler ngay khi component được tạo (lần đầu tiên)
    },
  },
  methods: {
    ...mapActions('compare', ['getCompareHeppers']),
    removeFilter() {
      if (!this.checkDefaultFilter({
        sort: 'created_at:-1',
        include: 'client,carrier,parcel,cross_check,shipment.invoice,shipment.invoice_fee',
        error_id: -1,
        status: -1,
        start_date: '',
        end_date: ''
      })) {
        this.reloadGsTable(this.compareTable)
      }
      this.filterDateRange = ''
      this.filters = {
        sort: 'created_at:-1',
        include: 'client,carrier,parcel,cross_check,shipment.invoice,shipment.invoice_fee',
        error_id: -1,
        status: -1,
        start_date: '',
        end_date: ''
      }
    },
    checkDefaultFilter(filters) {
      let diff = false
      let lkeys = keys(filters)
      forEach(lkeys, key => {
        if (filters[key] !== this.filters[key]) {
          this.diff = true
        }
      })
      return diff
    },
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.compareTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.compareTable)
      }
      this.$router.push({ query: this.filters })
    }, 300),
    updateFilters(data) {
      const startDate = data ? formatDate(data[0]) : null
      const endDate = data ? formatDate(data[1]) : null

      this.filters.start_date = startDate
      this.filters.end_date = endDate
      this.filter()
    },
    exportExcel() {
      this.toggleLoadding(true)
      exportExcel(this.filters).then(response => {
        this.toggleLoadding(false)
        window.location.href = response.full
      })
    }
  },
  mounted() {
    this.clickToCopy()
    if (ls.get('filters') && ls.get('filters')[this.compareTable]) {
      this.filters = ls.get('filters')[this.compareTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    if (!Object.keys(this.compareHelpers).length) {
      this.getCompareHeppers()
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.compareTable)
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['compares']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>



// WEBPACK FOOTER //
// ListtingAllCompare.vue?012dac96